import styled, { css } from 'styled-components';

import { media } from '@savgroup-front-common/constants';

import { Button } from '../button';

export const $ButtonGroupWrapper = styled.div`
  display: flex;
  margin-left: 1rem;

  & > button:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 1px solid transparent;
  }

  & > button:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const $ListPaginationButton = styled(Button)<{
  $isNewUiEnabled?: boolean;
}>`
  &,
  &:focus,
  &:active,
  &:visited {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2px;
    gap: 10px;
    background-color: transparent;
    border: 1px solid
      ${({ theme, $isNewUiEnabled }) =>
        $isNewUiEnabled
          ? theme.newUI.variationColors.light3
          : theme.colors.default};
    height: auto;
    min-height: auto;
    width: auto;
    min-width: auto;

    & > span > svg {
      color: ${({ theme, $isNewUiEnabled }) =>
        $isNewUiEnabled
          ? theme.newUI.defaultColors.primary
          : theme.colors.black};
      margin-right: 0;
    }

    &[disabled] {
      background-color: transparent;
      & > span > svg {
        color: ${({ theme }) => theme.colors.default};
      }
    }
  }

  &:hover {
    background-color: ${({ theme, $isNewUiEnabled }) =>
      $isNewUiEnabled
        ? theme.systemColors.defaultBackground
        : theme.colors.secondaryColor2};
    border: 1px solid ${({ theme }) => theme.colors.default};
    &:not(:first-child) {
      border-left: 1px solid transparent;
    }
    & > span > svg {
      color: ${({ theme, $isNewUiEnabled }) =>
        $isNewUiEnabled ? theme.newUI.defaultColors.primary : null};
    }
  }
`;

export const $ListPaginationInputText = styled.div<{
  $isNewUiEnabled?: boolean;
}>`
  display: flex;
  font-style: normal;
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  font-size: ${({ theme }) => theme.fonts.size.ultraSmall};
  text-align: right;
  color: ${({ theme }) => theme.colors.mainTextColor};
  white-space: nowrap;
  margin-left: 0.5rem;

  ${({ $isNewUiEnabled }) =>
    $isNewUiEnabled
      ? css`
          font-size: 12px;
          color: ${({ theme }) => theme.newUI.defaultColors.secondaryText};
          font-weight: ${({ theme }) => theme.fonts.weight.mediumFont};
        `
      : null}
`;

export const $ListPaginationInterval = styled.button<{
  $isActive: boolean;
  $isNewUiEnabled?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 8px;
  gap: 10px;
  border: 1px solid
    ${({ theme, $isNewUiEnabled }) =>
      $isNewUiEnabled
        ? theme.newUI.variationColors.light3
        : theme.colors.default};
  border-right: none;
  border-radius: 0;
  cursor: pointer;
  color: ${({ theme, $isActive }) => {
    if ($isActive) {
      return theme.colors.white;
    }

    return theme.colors.mainTextColor;
  }};

  background-color: ${({ theme, $isActive, $isNewUiEnabled }) => {
    if ($isNewUiEnabled && $isActive) {
      return theme.newUI.variationColors.dark1;
    }

    return $isActive
      ? theme.newUI.variationColors.dark1
      : theme.systemColors.defaultBackground;
  }};
`;

export const $ListPaginationIntervalOnlyNumber = styled.span`
  margin-right: 4px;
`;

export const $ListPaginationIntervalWrapper = styled.div`
  display: flex;
  align-items: center;

  & button:first-child {
    border-top-left-radius: 4px !important;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 4px !important;
  }

  & button:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
    border-bottom-left-radius: 0;

    border-right: 1px solid ${({ theme }) => theme.colors.default};
    margin-right: 0.5rem;
  }
`;

export const $ListPaginationPage = styled.div<{
  $isNewUiEnabled?: boolean;
}>`
  display: flex;
  align-items: center;

  && input {
    width: 70px;
    text-align: center;
    height: auto;
    padding: 4px 8px;
    border-color: ${({ theme, $isNewUiEnabled }) =>
      $isNewUiEnabled
        ? `${theme.newUI.variationColors.light3} !important`
        : null};
  }

  && > div {
    margin-bottom: 0;
  }
`;

export const $ListPaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const $Spacer = styled.div`
  flex: 1;
`;

export const $PaginationPerPage = styled.span<{ $isNewUiEnabled?: boolean }>`
  ${({ $isNewUiEnabled }) =>
    $isNewUiEnabled
      ? css`
          font-weight: ${({ theme }) => theme.fonts.weight.mediumFont};
          color: ${({ theme }) => theme.newUI.defaultColors.secondaryText};
          font-size: 12px;
        `
      : null}

  @media ${media.maxWidth.sm} {
    display: none;
  }
`;
